<header class="header-bar">
  <div class="header-content">
    <div class="logo-section">
      <img src="/assets/images/logo.svg" alt="Faraday Logo" class="logo" />
    </div>
    @if (user$ | async; as user) {
    <div class="user-section">
      <div class="user-avatar">
        <div class="avatar-circle">
          {{ user.first_name.charAt(0) + user.last_name.charAt(0) }}
        </div>
      </div>
      <span class="user-name">{{ user.first_name + ' ' + user.last_name }}</span>
      <button type="button" class="btn btn-link logout-btn" (click)="logout()" title="Logout">
        <i class="fas fa-sign-out-alt"></i>
      </button>
    </div>
    }
  </div>
</header>
